import { render, staticRenderFns } from "./palettes-not-found.vue?vue&type=template&id=780dd632&"
import script from "./palettes-not-found.vue?vue&type=script&lang=ts&"
export * from "./palettes-not-found.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports